module.exports = __webpack_public_path__ + "static/media/student4.b85f65de.svg";